import { transformGraphqlResponse } from '@repo/utils';

import { baseService } from './baseService';

const graphqlService = baseService.injectEndpoints({
  endpoints: (build) => ({
    getGraphqlData: build.query<any, {
      document: string,
      variables?: any,
      cacheKey?: string,
      cache?: boolean,
      cacheLifetime?: number,
      providesTags?: string[] | { type: string, id: string }[],
    }>({
      query: ({
        document,
        variables,
      }) => ({
        method: 'POST',
        url: '/graphql',
        body: { query: document, variables },
      }),
      providesTags(_, __, arg) { return arg?.providesTags ?? []; },
      transformResponse: transformGraphqlResponse,
    }),
  }),
});

export const {
  useGetGraphqlDataQuery,
  useLazyGetGraphqlDataQuery,
} = graphqlService;

export const createGraphqlServiceWithTransform = <T>(
  SERVICE_NAME: string,
  customTransformResponse: (response: T, dispatch: any) => T,
) => {
  const dynamicGraphqlService = baseService.injectEndpoints({
    endpoints: (build) => ({
      [SERVICE_NAME]: build.query<any, { document: string, variables?: any, dispatch: any }>({
        query: ({
          document,
          variables,
        }) => ({
          method: 'POST',
          url: '/graphql',
          body: { query: document, variables },
        }),
        transformResponse: (response, _, args) => {
          const transformedResponse = transformGraphqlResponse(response);
          return customTransformResponse(transformedResponse, args.dispatch);
        },
      }),
    }),
  });

  const useGetGraphqlDataQueryWithTransform = dynamicGraphqlService.endpoints[SERVICE_NAME]?.useQuery || (
    () => { throw new Error(`Endpoint ${SERVICE_NAME} not found`); });
  const useLazyGetGraphqlDataQueryWithTransform = dynamicGraphqlService.endpoints[SERVICE_NAME]?.useLazyQuery || (
    () => { throw new Error(`Endpoint ${SERVICE_NAME} not found`); });

  return {
    useGetGraphqlDataQuery: useGetGraphqlDataQueryWithTransform as typeof
      dynamicGraphqlService.endpoints[typeof SERVICE_NAME]['useQuery'],
    useLazyGetGraphqlDataQuery: useLazyGetGraphqlDataQueryWithTransform as typeof
      dynamicGraphqlService.endpoints[typeof SERVICE_NAME]['useLazyQuery'],
  };
};

export default graphqlService;
